import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsRemoteControlStyles: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    switchWrapper: {
        display: 'flex',
        paddingBottom: 20,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
}

addStyles(deviceSettingsRemoteControlStyles)
export default deviceSettingsRemoteControlStyles
